module.exports = __webpack_public_path__ + "static/media/dashboardsWhite.bd0ac422.svg";